import { Submission, SubmissionStatus } from '../../../types/models';

/**
 * The versions badged "active", and offered lock and transfer (CLD-2967/CONC-2,
 * D46): the live version of each group, as the API reports it in `IsLive`.
 *
 * Not the newest FINISHED row by `created_at`: a lower version can be promoted
 * after a higher one, and the API locks and transfers only the live version.
 * A row must also be FINISHED, as the lock endpoint requires. A response
 * without `IsLive` (an older API) badges nothing, so no action is offered that
 * the API would refuse.
 */
export const getActiveSubmissionIds = (submissions: Submission[]): number[] =>
  submissions
    .filter(
      (submission) =>
        submission.IsLive === true &&
        submission.Status === SubmissionStatus.Finished
    )
    .map((submission) => submission.id);
